import { useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import * as THREE from 'three';

interface ThirdPersonCameraProps {
  target: THREE.Vector3;
  forward: THREE.Vector3; // character's facing direction (normalized)
  distance?: number;
  height?: number;
}

/**
 * Fixed behind-the-back camera. Always follows the character,
 * positioned behind them based on their facing direction.
 * No mouse orbit — camera direction is locked to character.
 */
export default function ThirdPersonCamera({
  target,
  forward,
  distance = 8,
  height = 5,
}: ThirdPersonCameraProps) {
  const { camera } = useThree();

  useFrame((_, delta) => {
    // Camera sits behind the character: opposite of their forward direction
    const behind = forward.clone().multiplyScalar(-1).normalize();

    const targetCamPos = new THREE.Vector3(
      target.x + behind.x * distance,
      target.y + height,
      target.z + behind.z * distance,
    );

    // Smooth lerp
    camera.position.lerp(targetCamPos, Math.min(delta * 8, 1));

    // Look at character's head level
    camera.lookAt(target.x, target.y + 1.2, target.z);
  });

  return null;
}
